module.exports = __webpack_public_path__ + "img/commonLogo.44ed912c.jpg";